export class Attachment {
    id?: number;
    uploadedname?: string;
    resource_mimetype?: string;
    resource_url?: string;
    geom?: any;
    created_at?: any;
    delete_at?: any;
    fk_experience?: number;
    fk_item?: number;
    status?: string;
    sysdefined?: boolean;

    constructor() { 
        this.uploadedname = '',
        this.resource_url = '',
        this.resource_mimetype = '',
        this.sysdefined = false
       }
}

